import React from 'react';
import logo from '../assets/Untitled_design__22_-removebg-preview.png'; // Adjust path if different

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-logo-nav">
          <img src={logo} alt="Flint Sol Logo" className="footer-logo" />
          <nav className="footer-nav">
            <a href="#about">About</a>
            <a href="#services">Services</a>
            <a href="#portfolio">Portfolio</a>
            <a href="#industries">Industries</a>
            <a href="#contact">Contact</a>
          </nav>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; 2025 <strong>Flint Sol</strong>. All rights reserved. |
          <em> "Flint is a spark stone historically used to ignite fire, at Flint Sol we spark ideas into digital reality."</em>
        </p>
      </div>
    </footer>
    
  );
};

export default Footer;
